import { ChangeDetectionStrategy, Component, computed, inject, input, Signal } from '@angular/core';
import { PluginSeverity, PolicyLevel } from '@uigy/generated/graphql';
import { LanguageService } from '@uigy/shared/services/language.service';
import { NgClass } from '@angular/common';

export type SeverityVariant = 'info' | 'low' | 'medium' | 'high' | 'critical' | 'none';

@Component({
    selector: 'app-ui-severity-pill',
    imports: [
        NgClass
    ],
    templateUrl: './severity-pill.component.html',
    styleUrl: './severity-pill.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SeverityPillComponent {
  private languageService = inject(LanguageService);
  private severityTexts = this.languageService.texts.general.grid.severity;

  public score = input.required<PluginSeverity | PolicyLevel>();
  public variant: Signal<SeverityVariant> = computed(() => this.getVariant());
  public title: Signal<string> = computed(() => this.getTitle());

  private getVariant(): SeverityVariant {
    const score = this.score();
    switch (score) {
      case PluginSeverity.Info:
        return 'info';
      case PluginSeverity.Low:
      case PolicyLevel.Low:
        return 'low';
      case PluginSeverity.Medium:
      case PolicyLevel.Medium:
        return 'medium';
      case PluginSeverity.High:
      case PolicyLevel.High:
        return 'high';
      case PluginSeverity.Critical:
        return 'critical';
      case PolicyLevel.None:
      default:
        return 'none';
    }
  }

  private getTitle(): string {
    const score = this.score();
    switch (score) {
      case PluginSeverity.Info:
        return this.severityTexts.info;
      case PluginSeverity.Low:
      case PolicyLevel.Low:
        return this.severityTexts.low;
      case PluginSeverity.Medium:
      case PolicyLevel.Medium:
        return this.severityTexts.medium;
      case PluginSeverity.High:
      case PolicyLevel.High:
        return this.severityTexts.high;
      case PluginSeverity.Critical:
        return this.severityTexts.critical;
      case PolicyLevel.None:
      default:
        return this.severityTexts.none;
    }
  }
}
